import { render, staticRenderFns } from "./ThreadsIcon.vue?vue&type=template&id=39bf765d&scoped=true"
var script = {}
import style0 from "./ThreadsIcon.vue?vue&type=style&index=0&id=39bf765d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf765d",
  null
  
)

export default component.exports